<template>
    <b-modal
        cancel-title="Abbrechen"
        modal-class="email-user-assignment-modal info-card editMode"
        :ok-disabled="!hasChanged"
        ok-title="Zuweisen"
        size="md"
        title="Bearbeiter zuweisen"
        :visible="show"
        @hidden="onHidden"
        @ok.prevent="onConfirm">
        <div v-if="isLoading" class="d-flex justify-content-center pt-4">
            <csp-loading-indicator/>
        </div>
        <div v-if="!isLoading">
            <b-form-group
                class="info-card-element"
                label="Bearbeiter"
                label-for="reminder-date-input">
                <csp-form-select-searchable
                    :allow-empty="true"
                    :options="userOptions"
                    :value="currentUserId"
                    @change="onUserChange"/>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
import '@desktop/scss/components/digital-mailbox.scss';
import Container from '@services/Container';
import LoadingIndicator from '@components/LoadingIndicator';
import SelectSearchable from '@components/form/SelectSearchable';

const container = Container.getInstance();
const digitalMailboxRepository = container.getDigitalMailboxRepository();

export default {
    name: 'EmailUserAssignmentModal',
    components: {
        'csp-form-select-searchable': SelectSearchable,
        'csp-loading-indicator': LoadingIndicator,
    },
    props: {
        emailId: {
            default: null,
            type: [Number, String],
        },
        initialUserId: {
            default: null,
            type: [Number, null],
        },
        show: {
            required: true,
            type: Boolean,
        },
    },
    emits: ['cancel', 'confirm'],
    data() {
        return {
            currentUserId: null,
            isLoading: false,
            userOptions: [],
        };
    },
    computed: {
        hasChanged() {
            const currentNormalized = this.currentUserId || null;
            return currentNormalized !== (this.initialUserId || null);
        },
    },
    watch: {
        show(newVal) {
            if (newVal) {
                this._loadOptions();
            }
        },
    },
    methods: {
        onConfirm() {
            if (!this.hasChanged) {
                return;
            }
            const userId = this.currentUserId || 0;
            this.$emit('confirm', {userId});
        },
        onHidden() {
            this.$emit('cancel');
        },
        onUserChange(option) {
            this.currentUserId = option ? option.value : null;
        },
        _loadOptions() {
            if (!this.emailId) {
                return;
            }
            this.isLoading = true;
            this.userOptions = [];
            this.currentUserId = this.initialUserId || 0;
            digitalMailboxRepository.loadUserAssignmentOptions(this.emailId)
                .then((options) => {
                    this.userOptions = options;
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    },
};
</script>
